import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';
import './Header.css';

function Header({ isMobile, toggleSidebar }) {
  const { isAuthenticated, logout } = useAuth();
  const { theme } = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          {isAuthenticated && isMobile && (
            <button className="menu-button" onClick={toggleSidebar}>
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </button>
          )}
          
          <Link to="/" className="logo">
            <img 
              src={theme === 'dark' ? "/logo.png" : "/logo_dark.png"} 
              alt="Channls" 
              className="logo-image" 
            />
          </Link>
        </div>
        
        <div className="header-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="dashboard-link">
              <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="14" y="14" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
              </svg>
              <span>Dashboard</span>
            </Link>
          ) : (
            <nav className="nav">
              <ul className="nav-list">
                <li className="nav-item">
                  <Link to="/login" className="nav-link">
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path>
                      <polyline points="10 17 15 12 10 7"></polyline>
                      <line x1="15" y1="12" x2="3" y2="12"></line>
                    </svg>
                    <span>Login</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/register" className="btn btn-primary">
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="8.5" cy="7" r="4"></circle>
                      <line x1="20" y1="8" x2="20" y2="14"></line>
                      <line x1="23" y1="11" x2="17" y2="11"></line>
                    </svg>
                    <span>Register</span>
                  </Link>
                </li>
              </ul>
            </nav>
          )}
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}

export default Header; 